import TypographyWrapper from '@/components/comman/TypographyWrapper/TypographyWrapper'
import cn from 'clsx'
import style from './style.module.css'

const StatsItem = ({
  itemData,
  index,
  isLastItem,
  outlined = false,
}: {
  itemData: any
  index: number
  isLastItem: boolean
  outlined?: boolean
}) => {
  const statsParentClass = cn('flex justify-center items-center w-full flex-col text-center flex-wrap', {
    'gap-2.5 sm:gap-3.5 bg-white': outlined,
    'md:gap-1.5 gap-1 pr-3': !outlined,
  })
  return (
    <div className='w-full flex justify-between items-center'>
      <div className={statsParentClass}>
        {itemData?.img && <img src={itemData?.img} className='h-8 w-8 md:h-12 md:w-12' alt='Img' />}
        {outlined ? (
          <div className='sm:gap-2.5'>
            <TypographyWrapper variant='regular' weight='semi-bold' color='#1b2124'>
              <span className='text-[#1b2124]'>{itemData?.quantity}</span>
            </TypographyWrapper>
            <TypographyWrapper variant='regular' color='#3D3D3D' component='div' weight='medium'>
              <span className='text-[#3D3D3D]'>{itemData?.title}</span>
            </TypographyWrapper>
          </div>
        ) : (
          <>
            <TypographyWrapper
              variant='heading2'
              weight='semi-bold'
              color='#1b2124'
              component='div'
              className="whitespace-nowrap text-ellipsis overflow-hidden w-full break-words sm:leading-8 lg:leading-12"
            >
              <span className='text-[#1b2124]'>{itemData?.quantity}</span>
            </TypographyWrapper>
            <TypographyWrapper
              variant='subHeading'
              color='#3D3D3D'
              component='div'
              className="whitespace-nowrap text-ellipsis overflow-hidden w-full break-words leading-6 lg:leading-7"
              weight='medium'
            >
              <span className='text-[#3D3D3D]'>{itemData?.title}</span>
            </TypographyWrapper>
          </>
        )}
      </div>
      {!isLastItem && outlined && (
        <div
          className='w-[1px] h-16 bg-[#e5e7eb] hidden sm:block mx-2.5 flex-shrink-0'
        />
      )}
    </div>
  )
}

export default StatsItem
